//能耗分析模型
import request from "./http";
import qs from 'qs'


// *能耗分析模型->根据单位id获取能耗模型树
export function findModelTree(params) {
    return request({
        url: "/dissipation/model/findModelTree",
        method: "get",
        params
    });
}

// *能耗分析模型->新增能耗分析模型
// modelName 模型名称
// modelType 	模型类型
// parentId 父级id:顶级需传0
// unitId 单位id
export function saveDissipation(params) {
    return request({
        url: "/dissipation/model/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params
    });
}

// *能耗分析模型->修改能耗分析模型
// modelName 模型名称
// modelType 	模型类型
// parentId 父级id:顶级需传0
// unitId 单位id
// id  主键id
export function updateDissipation(params) {
    return request({
        url: "/dissipation/model/update",
        method: "put",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params
    });
}


// *能耗分析模型->删除能耗分析模型
//  id id
export function deleteDissipation(params) {
    return request({
        url: "/dissipation/model/delete",
        method: "delete",
        params
    });
}

// *能耗分析模型->根据模型id获取绑定设备列表
//  id id
export function dissipaFinDevice(params) {
    return request({
        url: "/dissipation/binding/finDevice",
        method: "get",
        params
    });
}

// *能耗分析模型->耗能模型绑定设备
export function dissipationSave(params) {
    return request({
        url: "/dissipation/binding/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
          data:params

    });
}

// *能耗分析模型->移除耗能模型绑定设备
// 
export function dissipationRemove(params) {
    return request({
        url: "/dissipation/binding/remove",
        method: "delete",
        params
    });
}

// *能耗分析模型->能耗统计查询，支持年-月-日
export function dissipaEnergy(params) {
    return request({
        url: "/dissipation/metering/energy",
        method: "get",
        params
    });
}

// /dissipation/metering/energy